export default "__VITE_ASSET__6H3X6yDC__"